import React, {useEffect, useState} from "react";
import i18n from '../../i18n';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Hidden from "@material-ui/core/Hidden";
import TableBody from "@material-ui/core/TableBody";
import {Typography, withStyles} from "@material-ui/core";
import PhoneLinkButton from "../Formater/PhoneLinkButton";
import LinkIconButton from "../Formater/LinkIconButton";
import Button from "@material-ui/core/Button";
import TableRowClickable from "../Form/TableRowClickable";
import TowLine from "../Text/TwoLine";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Icon from "@material-ui/core/Icon/Icon";
import DeleteButton from "../Form/DeleteButton";
import FormCheck from "../Form/FormCheck";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";


const cleanPhone = (phone) => {
    let num = phone.match(/[\d\\+]+/g);
    return num ? num.join('').replace('+', '00') : '';
};

const renderShow = (contact, classes) => {
    return (
        <IconButton className={classes.iconButton}
                    component="a"
                    href={`/contacts/${contact.contact_type}/${contact.id}`}
        >
            <Icon className={classes.iconButtonIcon}>find_in_page</Icon>
        </IconButton>
    );
};

const renderEdit = (contact, classes) => {
    if (!window.can('contacts.update')) {
        return null;
    }

    return (
        <IconButton className={classes.iconButton}
                    href={`/contacts/${contact.contact_type}/${contact.id}/edit`}
                    dusk={`edit-contact${contact.id}`}>
            <Icon className={classes.iconButtonIcon}>edit</Icon>
        </IconButton>
    )
};

const ContactTable = ({contacts, setContacts, parent, edit, classes , ...rest}) => {

    const [keyContacts,setKeyContacts] = useState(
        parent && parent.key_contacts ? [].concat( parent.key_contacts.split(',') ) : []
    )

    // called, if the user is clicking the button to select the keyContacts values
    const handleKeyContacts = (id) => {
        //id = parseInt(id);
        if(keyContacts.includes(id)){
            let idx = keyContacts.findIndex((e) => e === id);
            keyContacts.splice(idx,1);
        } else {
            keyContacts.push(id);
        }
        setKeyContacts(keyContacts);
        formatContacts();
    };

    // send formatted keyContact data to contact form
    const formatContacts = () => {
        let formCons = [];
        (keyContacts || []).map(id => {
            let item = contacts.find(contact => contact.id === id);
            item && formCons.push(`${item.first_name} ${item.last_name}`);
        });
        setContacts(formCons.join(', '));
        parent.key_contacts = keyContacts.join(',');
    };

    // will be called after rendering the parent component - the keyContact initializing
    useEffect(() => {
        formatContacts();
    },[keyContacts]);

    return (
        <React.Fragment>
            <Table className={classes.list}>
                <TableHead>
                    <TableRow>
                        <TableCell> </TableCell>
                        <TableCell>
                            {i18n.get('contacts.name')}
                        </TableCell>
                        <TableCell>
                            {i18n.get('contacts.scope')}
                        </TableCell>
                        <TableCell>{i18n.get('contacts.landline')} / {i18n.get('contacts.mobile')}</TableCell>
                        <TableCell>{i18n.get('contacts.email')}</TableCell>
                        <TableCell align="center">{i18n.get('contacts.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { contacts.map( (contact, idx) => (
                        <TableRowClickable className={classes.tableRow} key={`contact_${contact.id}`} action={`/contacts/${contact.contact_type}/${contact.id}`}>
                            <TableCell>
                                {keyContacts.includes(contact.id) && (
                                    <Tooltip title={i18n.get('contacts.key_contact.self')}>
                                        <Icon className={classes.iconButtonIcon} color={'primary'}>account_circle</Icon>
                                    </Tooltip>
                                )}
                            </TableCell>
                            <TableCell>
                                <Typography component={'h6'}>
                                    {contact.first_name} {contact.last_name}
                                </Typography>
                            </TableCell>
                            <TableCell className={classes.description}>
                                <Typography component={'h6'}>
                                    <EllipsisWithTooltip className={classes.popser}
                                        placement="bottom-start"
                                        title={contact.description}
                                    >
                                        {contact.description}
                                    </EllipsisWithTooltip>
                                </Typography>
                            </TableCell>
                            <TableCell onClick={e => { e.stopPropagation('all'); }} style={{cursor:'default'}}>
                                <Grid container direction="column" justify="center" alignItems="flex-start">
                                    {contact.landline && (
                                        <Grid item>
                                            <LinkIconButton
                                                href={`tel:${cleanPhone(contact.landline)}`}
                                                text={contact.landline}
                                                icon={'phone'}
                                                fontSize={'small'}
                                                {...rest}
                                            />
                                        </Grid>
                                    )}
                                    {contact.mobile && (
                                        <Grid item>
                                            <LinkIconButton
                                                href={`tel:${cleanPhone(contact.mobile)}`}
                                                text={contact.mobile}
                                                icon={'smartphone'}
                                                {...rest}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </TableCell>
                            <TableCell onClick={e => { e.stopPropagation('all'); } } style={{cursor:'default'}}>
                                {contact.email &&(
                                    <LinkIconButton
                                        buttonProps={{style:{textTransform: 'lowercase'}}}
                                        text={contact.email}
                                        href={`mailto:${contact.email}`}
                                        icon={'email'}
                                    />
                                )}
                            </TableCell>
                            <TableCell  align="center" onClick={e => { e.stopPropagation('all'); } } style={{cursor:'default'}}>
                                <TowLine
                                    main={
                                        <React.Fragment>
                                            {!edit && renderShow(contact, classes)}
                                            {renderEdit(contact, classes)}
                                            {edit && (
                                                <Tooltip title={i18n.get('contacts.key_contact.' + (keyContacts.includes(contact.id) ? 'remove_flag':'set_flag'))}>
                                                    <Button
                                                        size={'small'}
                                                        className={keyContacts.includes(contact.id)? classes.iconButtonActive : classes.iconButton}
                                                        onClick={() => handleKeyContacts(contact.id)}
                                                    >
                                                        <Icon className={classes.iconButtonIcon}>account_circle</Icon>
                                                    </Button>
                                                </Tooltip>
                                            )}
                                        </React.Fragment>
                                    }
                                />
                            </TableCell>
                        </TableRowClickable>
                    )) }
                </TableBody>
            </Table>
        </React.Fragment>

    );
};

const styles = theme => ({
    iconButton: {
        width: 32,
        height: 32,
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,
        '&:hover': {
            color: theme.colors.primary,
            opacity: 1,
            outline:'none',
        },
        '&:focus': {
            outline:'none',
        }
    },
    iconButtonActive:{
        width: 32,
        height: 32,
        fontSize: 12,
        padding: '8px',
        color: theme.colors.primary,
        opacity: 1,
        '&:hover': {
            opacity: 0.5,
            outline:'none',
            color: theme.colors.lightGreyBlue,
        },
        '&:focus': {
            outline:'none',
        }
    },
    iconButtonIcon: {
        fontSize: 22,
    },

    tableRow: {
        maxHeight: 50,
    },

    description:{
        maxWidth: 250,
        height: 'auto !important',
        whiteSpace: 'nowrap',
        overflow:'hidden',
        textOverflow: 'ellipsis',
    },
    popper: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: 22,
        border: '1px solid #dadde9',
    },
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    },
});

export default withStyles(styles)(ContactTable);
